import { supportsRequestBody } from '../utils';

import { appendQueryParams, createFetchError, getRequestBody, inferResponseType, readResponse } from './utils';

import type { IFetchOptions, TypeFetchResponse } from './types';

// ----------------------------------------------------------------------------

async function fetch<T = unknown>(options: IFetchOptions<T>): Promise<TypeFetchResponse<T>> {
    const { url, method = 'GET', headers = {}, data, responseType, signal, onProgress } = options;

    const requestUrl = supportsRequestBody(method) ? url : appendQueryParams(url, data);
    const requestHeaders = { ...headers };

    const body = getRequestBody(method, data, requestHeaders);

    const response = await window.fetch(requestUrl, {
        method,
        headers: requestHeaders,
        body,
        signal,
    });

    if (!response.ok) {
        throw await createFetchError(response);
    }

    const responseData = await readResponse<T>(response, responseType ?? inferResponseType(response), onProgress);

    return {
        data: responseData,
        response,
    };
}

// ----------------------------------------------------------------------------

export default fetch;
